import React from 'react';
import './styles/background.css';

// Purely decorative backdrop — no text, no interaction, so it stays out of the
// accessibility tree and never eats a click meant for the content above it.
export default function Background() {
  return (
    <div className="site-bg" aria-hidden="true">
      <div className="site-bg__glow" />
      <div className="site-bg__vignette" />
      <div className="site-bg__grid-mask">
        <div className="site-bg__grid" />
      </div>
      <div className="site-bg__rails" />
      <div className="site-bg__noise" />
    </div>
  );
}
